export default __webpack_public_path__ + "static/media/aluminum.6c08e101.png";